import type { ReactNode } from 'react';
import { CssBaseline, Typography } from '@mui/material';
import { HashRouter as Router, Route, Routes } from 'react-router-dom';
import { AuthProvider, useAuth } from '../auth/AuthContext';
import { LocaleProvider, useLocale } from '../i18n/LocaleContext';
import Login from '../pages/Login/Login';
import NotFound from '../pages/NotFound/NotFound';
import Profile from '../pages/Profile/Profile';
import Schedule from '../pages/Schedule/Schedule';

const RequireAuth = ({ children }: { children: ReactNode }) => {
  const { user } = useAuth();
  if (!user) return <NotFound />;
  return children;
};

const AppRoutes = () => {
  const { ready } = useAuth();
  const { t } = useLocale();

  if (!ready) {
    return (
      <Typography
        variant="body1"
        color="text.secondary"
        sx={{ p: 4, minHeight: '100dvh', background: '#f4f6f8' }}
      >
        {t('checkingSession')}
      </Typography>
    );
  }

  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/login" element={<Login />} />
      <Route
        path="/schedule"
        element={
          <RequireAuth>
            <Schedule />
          </RequireAuth>
        }
      />
      <Route
        path="/profile"
        element={
          <RequireAuth>
            <Profile />
          </RequireAuth>
        }
      />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

const App = () => {
  return (
    <LocaleProvider>
      <CssBaseline />
      <Router>
        <AuthProvider>
          <AppRoutes />
        </AuthProvider>
      </Router>
    </LocaleProvider>
  );
};

export default App;
